"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepRename = void 0;
var _isObject = require("./isObject");
var deepRename = function deepRename(obj, getNewKey) {
  var out;
  if (Array.isArray(obj)) {
    out = [];
    for (var i = 0; i < obj.length; i += 1) {
      out.push(deepRename(obj[i], getNewKey));
    }
  } else if ((0, _isObject.isObject)(obj)) {
    out = {};
    Object.keys(obj).forEach(function (key) {
      var newKey = getNewKey(key);
      out[newKey] = obj[key];
      if ((0, _isObject.isObject)(out[newKey])) {
        out[newKey] = deepRename(out[newKey], getNewKey);
      }
    });
  }
  return out || obj;
};
exports.deepRename = deepRename;